/**
 * Gradienta announcement bar, header Shop menu, phone menu and footer.
 * - Announcement: previous / next, rotates unless reduced motion; pauses on hover or focus.
 * - Shop menu: button toggles the panel; opens on hover with a mouse; Escape or a click
 *   outside closes it and focus returns to the button.
 * - Phone menu and footer: expandable sections ([data-gr-acc], [data-gr-facc]). The phone
 *   menu is copied into the theme drawer when it opens, so clicks are handled on document.
 * - Footer country selector submits on change.
 * - Cookie settings buttons ([data-gr-cookie-prefs]) reopen Shopify's cookie banner.
 */
(function () {
  'use strict';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initAnnouncement(root) {
    const msgs = Array.from(root.querySelectorAll('[data-gr-ann-msg]'));
    if (msgs.length < 2) return;
    let i = 0, timer = null, paused = false;
    const seconds = Math.max(3, parseInt(root.dataset.interval, 10) || 5);
    function show(n) {
      i = (n + msgs.length) % msgs.length;
      msgs.forEach((m, k) => {
        const on = k === i;
        m.classList.toggle('is-active', on);
        m.setAttribute('aria-hidden', String(!on));
        const a = m.querySelector('a');
        if (a) a.tabIndex = on ? 0 : -1;
      });
    }
    function start() { if (!reduce && !timer) timer = setInterval(() => { if (!paused) show(i + 1); }, seconds * 1000); }
    const prev = root.querySelector('[data-gr-ann-prev]');
    const next = root.querySelector('[data-gr-ann-next]');
    if (prev) prev.addEventListener('click', () => show(i - 1));
    if (next) next.addEventListener('click', () => show(i + 1));
    root.addEventListener('mouseenter', () => { paused = true; });
    root.addEventListener('mouseleave', () => { paused = false; });
    root.addEventListener('focusin', () => { paused = true; });
    root.addEventListener('focusout', () => { paused = false; });
    start();
  }

  function initMega(btn) {
    const panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    const header = btn.closest('.gr-hd') || btn.parentElement;
    let closeTimer = null;
    let hoverOpenedAt = 0;
    const hoverable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    function open() { clearTimeout(closeTimer); panel.hidden = false; btn.setAttribute('aria-expanded', 'true'); }
    function close(focusBack) {
      panel.hidden = true; btn.setAttribute('aria-expanded', 'false');
      if (focusBack) btn.focus();
    }
    // A click that follows a hover-open (the mouse arrives, then clicks) keeps it open
    btn.addEventListener('click', () => {
      if (panel.hidden) open();
      else if (Date.now() - hoverOpenedAt > 700) close(false);
    });
    if (hoverable) {
      btn.addEventListener('mouseenter', () => { if (panel.hidden) { hoverOpenedAt = Date.now(); open(); } });
      header.addEventListener('mouseleave', () => { closeTimer = setTimeout(() => close(false), 220); });
      header.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    }
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !panel.hidden) close(panel.contains(document.activeElement) || document.activeElement === btn);
    });
    document.addEventListener('click', (e) => { if (!panel.hidden && !header.contains(e.target)) close(false); });
    panel.addEventListener('focusout', (e) => {
      if (!panel.hidden && e.relatedTarget && !header.contains(e.relatedTarget)) close(false);
    });
  }

  function init(scope) {
    const s = scope || document;
    s.querySelectorAll('[data-gr-ann]').forEach((el) => { if (!el.grInit) { el.grInit = true; initAnnouncement(el); } });
    s.querySelectorAll('[data-gr-mega-toggle]').forEach((el) => { if (!el.grInit) { el.grInit = true; initMega(el); } });
  }

  // Expandable sections (phone menu content is injected later, so listen on document)
  document.addEventListener('click', (e) => {
    const acc = e.target.closest('[data-gr-acc], [data-gr-facc]');
    if (!acc) return;
    const open = acc.getAttribute('aria-expanded') !== 'true';
    acc.setAttribute('aria-expanded', String(open));
    if (acc.hasAttribute('data-gr-acc')) {
      const panel = acc.nextElementSibling;
      if (panel) panel.hidden = !open;
    }
  });
  // Cookie settings buttons reopen Shopify's cookie banner. They stay hidden until the banner script is ready.
  function showCookieButtons() {
    if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') return false;
    document.querySelectorAll('[data-gr-cookie-prefs][hidden]').forEach((b) => { b.hidden = false; });
    return true;
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-gr-cookie-prefs]');
    if (b && window.privacyBanner) { e.preventDefault(); window.privacyBanner.showPreferences(); }
  });
  window.addEventListener('load', () => { if (!showCookieButtons()) setTimeout(showCookieButtons, 2000); });
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-gr-autosubmit]') && e.target.form) e.target.form.submit();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
